import {fromUrlToFilters, objectToArray, TAGS_FILTER_PARAM} from 'shared/lib/filterHelper';
import IOrderBy from 'shared/model/IOrderBy';

import IHttpMonitorsFilters from 'features/http/model/HttpMonitor/IHttpMonitorsFilters';
import HttpIncidentFilters from 'features/http/model/HttpIncident/IHttpIncidentFilters';
import IHttpMonitorsFiltersLog from 'features/http/model/HttpMonitor/IHttpMonitorsFiltersLog';

export const HTTP_MONITORS_DEFAULT_SORT: IOrderBy = {field: 'id', direction: 'desc'};

export const HTTP_MONITORS_ORDER_FIELDS: readonly string[] = [
    'id',
    'name',
    'url',
    'availability1',
    'checkInterval',
    'status',
    'lastCode',
];

export const HTTP_INCIDENTS_DEFAULT_SORT: IOrderBy = {field: 'resolved', direction: 'asc'};

export const HTTP_INCIDENTS_ORDER_FIELDS: readonly string[] = [
    'id',
    'resolved',
    'monitor.url',
    'created_at',
    'resolved_at',
    'duration',
];

export function getHttpMonitorsFilters(params: URLSearchParams): IHttpMonitorsFilters {
    const filters: IHttpMonitorsFilters = {};
    fromUrlToFilters(params, filters, 'name');
    fromUrlToFilters(params, filters, 'url');
    fromUrlToFilters(params, filters, 'status');
    fromUrlToFilters(params, filters, 'ok');
    fromUrlToFilters(params, filters, 'days');
    const tags = params.getAll(TAGS_FILTER_PARAM);
    if (tags.length > 0) {
        filters.tags = tags;
    }
    return filters;
}

export function getHttpIncidentFilters(params: URLSearchParams): HttpIncidentFilters {
    const filters: HttpIncidentFilters = {};
    fromUrlToFilters(params, filters, 'monitor.url');
    fromUrlToFilters(params, filters, 'resolved');
    fromUrlToFilters(params, filters, 'created_at[after]');
    fromUrlToFilters(params, filters, 'created_at[before]');
    fromUrlToFilters(params, filters, 'resolved_at[after]');
    fromUrlToFilters(params, filters, 'resolved_at[before]');
    const duration = Number(params.get('duration'));
    if (duration) {
        filters.duration = duration;
    }

    return filters;
}

export function getHttpMonitorsFilterArray(params: URLSearchParams): string[] {
    return objectToArray(getHttpMonitorsFilters(params));
}

export function getHttpIncidentFilterArray(params: URLSearchParams): string[] {
    return objectToArray(getHttpIncidentFilters(params));
}

export function getHttpMonitorsFiltersLog(params: URLSearchParams): IHttpMonitorsFiltersLog {
    const filters: IHttpMonitorsFiltersLog = {};
    fromUrlToFilters(params, filters, 'code');
    fromUrlToFilters(params, filters, 'message');
    fromUrlToFilters(params, filters, 'checkedAt[after]');
    fromUrlToFilters(params, filters, 'checkedAt[before]');
    return filters;
}
